import { createEntityAdapter, EntityState } from "@reduxjs/toolkit";
import { Trigger_Entity } from "../../entities/trigger";
import { autopilotApi } from "../api/autopilotApi";

const triggersAdapter = createEntityAdapter<Trigger_Entity>();
const initialState = triggersAdapter.getInitialState();

export const triggerEndpoints = autopilotApi.injectEndpoints({
  endpoints: (build) => ({
    getTriggers: build.query<EntityState<Trigger_Entity>, void>({
      query: () => `triggers`,
      transformResponse: (responseData: Trigger_Entity[]) => {
        return triggersAdapter.setAll(initialState, responseData);
      },
      providesTags: ["triggers"],
    }),
    getTrigger: build.query<Trigger_Entity, number>({
      query: (id) => `triggers/${id}`,
      providesTags: (result, error, id) => [{ type: "triggers", id }],
    }),
    createTrigger: build.mutation<Trigger_Entity, Partial<Trigger_Entity>>({
      query: (body) => ({
        method: "POST",
        body,
        url: `triggers`,
      }),
      invalidatesTags: ["triggers"],
    }),
    updateTrigger: build.mutation<
      void,
      { id: number; body: Partial<Trigger_Entity> }
    >({
      query: (args) => ({
        method: "PUT",
        body: args.body,
        url: `triggers/${args.id}`,
      }),
      invalidatesTags: ["triggers"],
    }),
    deleteTrigger: build.mutation<void, number>({
      query: (id) => ({
        method: "DELETE",
        url: `triggers/${id}`,
      }),
      invalidatesTags: ["triggers"],
    }),
  }),
});

export const {
  useGetTriggerQuery,
  useGetTriggersQuery,
  useCreateTriggerMutation,
  useDeleteTriggerMutation,
  useUpdateTriggerMutation,
} = triggerEndpoints;
